export default __webpack_public_path__ + "static/media/eth2.549400e7.svg";